"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[259],{

/***/ 7259:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ AboutContainer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(6734);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(1776);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(4078);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(8757);
// EXTERNAL MODULE: ./hooks/useRender.ts
var useRender = __webpack_require__(3890);
;// CONCATENATED MODULE: ./hooks/useWindowSize.ts

const useWindowSize = ()=>{
    const [windowSize, setWindowSize] = (0,react.useState)({
        width: 1280,
        height: 768
    });
    const handleSize = ()=>{
        setWindowSize({
            width: window.innerWidth,
            height: window.innerHeight
        });
    };
    (0,react.useEffect)(()=>{
        handleSize();
        window.addEventListener("resize", handleSize);
        return ()=>window.removeEventListener("resize", handleSize);
    }, []);
    return windowSize;
};
/* harmony default export */ var hooks_useWindowSize = (useWindowSize);

// EXTERNAL MODULE: ./hooks/useTabs.ts
var useTabs = __webpack_require__(8083);
;// CONCATENATED MODULE: ./containers/About/About.tsx







const Info = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(779), __webpack_require__.e(488)]).then(__webpack_require__.bind(__webpack_require__, 8488)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(8488)
            ]
    },
    ssr: true
});
const Locations = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(562), __webpack_require__.e(454)]).then(__webpack_require__.bind(__webpack_require__, 9454)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(9454)
            ]
    },
    ssr: true
});
const Sticky = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(562), __webpack_require__.e(925)]).then(__webpack_require__.bind(__webpack_require__, 2925)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(2925)
            ]
    },
    ssr: true
});
function AboutContainer(param) {
    let { profile  } = param;
    const isLocationRenderable = (0,useRender/* useCanRender */.f)("location");
    const { t  } = (0,useTranslation/* default */.Z)("common");
    const description = profile.description || t("sections.about.description");
    const { width  } = hooks_useWindowSize();
    const locationLabel = (0,useTabs/* useMakeLabel */.q)("location", 80);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "grid grid-cols-1 md:grid-cols-12 md:gap-8 lg:gap-10 xl:gap-14 gap-y-10 mb-6",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "col-span-12 lg:col-span-6 xl:col-span-7",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Info, {
                            businessName: profile.name,
                            description: description
                        }),
                        width < 1024 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Sticky, {
                            profile: profile
                        }),
                        isLocationRenderable && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: "font-medium text-lg xl:text-xl mb-4 mt-8 lg:mt-10",
                                    children: locationLabel
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Locations, {
                                    locations: profile.locations
                                })
                            ]
                        })
                    ]
                }),
                width > 1024 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Sticky, {
                    profile: profile
                })
            ]
        })
    });
}


/***/ }),

/***/ 8083:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ useMakeLabel; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1776);
/* harmony import */ var hooks_useRender__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3890);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8757);
/* harmony import */ var _useFetch__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9350);
/* harmony import */ var utils_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8728);





const useMakeLabel = function(field) {
    let limit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 13;
    const { data: businessProfile  } = (0,_useFetch__WEBPACK_IMPORTED_MODULE_3__/* .useBusinessProfile */ .jB)();
    const widgetSetting = businessProfile === null || businessProfile === void 0 ? void 0 : businessProfile.data.widget;
    const { t , lang  } = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("common");
    // const fieldToSection: any = `${field}s`;
    // const itemsCount = useHowManyItems(fieldToSection);
    const fallbackName = "navigation.".concat(field);
    const titleFromData = (field)=>{
        var _translations_field;
        const translations = widgetSetting === null || widgetSetting === void 0 ? void 0 : widgetSetting.settings.language.translations[lang];
        if (!translations) return null;
        return (_translations_field = translations[field]) === null || _translations_field === void 0 ? void 0 : _translations_field.trimEnd();
    };
    return (0,utils_utils__WEBPACK_IMPORTED_MODULE_4__/* .generateSectionLabel */ .UT)(titleFromData(field), t(fallbackName), limit);
};
const useTabs = ()=>{
    const { t  } = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("common");
    const isProviderRenderable = (0,hooks_useRender__WEBPACK_IMPORTED_MODULE_1__/* .useCanRender */ .f)("provider");
    const isReviewRenderable = (0,hooks_useRender__WEBPACK_IMPORTED_MODULE_1__/* .useCanRender */ .f)("review");
    const hasProvidersItems = (0,hooks_useRender__WEBPACK_IMPORTED_MODULE_1__/* .useHowManyItems */ ._)("providers") > 0;
    const hasReviewsItems = (0,hooks_useRender__WEBPACK_IMPORTED_MODULE_1__/* .useHowManyItems */ ._)("reviews") > 0;
    const hasServicesItems = (0,hooks_useRender__WEBPACK_IMPORTED_MODULE_1__/* .useHowManyItems */ ._)("services") > 0;
    const providerLabel = useMakeLabel("provider");
    const serviceLabel = useMakeLabel("service");
    const reviewLabel = useMakeLabel("review");
    const tabs = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>{
        return [
            {
                id: 0,
                label: t("navigation.about"),
                path: "about",
                visible: true
            },
            {
                id: 1,
                label: providerLabel,
                path: "providers",
                visible: hasProvidersItems && isProviderRenderable
            },
            {
                id: 2,
                label: serviceLabel,
                path: "services",
                visible: hasServicesItems
            },
            {
                id: 3,
                label: reviewLabel,
                path: "reviews",
                visible: hasReviewsItems && isReviewRenderable
            }
        ];
    }, [
        hasProvidersItems,
        hasReviewsItems,
        hasServicesItems,
        isProviderRenderable,
        isReviewRenderable,
        providerLabel,
        reviewLabel,
        serviceLabel,
        t
    ]);
    return tabs;
};
/* harmony default export */ __webpack_exports__["Z"] = (useTabs);


/***/ }),

/***/ 8728:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BB": function() { return /* binding */ isProd; },
/* harmony export */   "Ee": function() { return /* binding */ generateSocialShare; },
/* harmony export */   "Eh": function() { return /* binding */ toSearchEngineFriendlyWords; },
/* harmony export */   "Hl": function() { return /* binding */ getNameOfDay; },
/* harmony export */   "UT": function() { return /* binding */ generateSectionLabel; },
/* harmony export */   "V5": function() { return /* binding */ formatTime24; },
/* harmony export */   "_2": function() { return /* binding */ generateBookingURL; },
/* harmony export */   "aS": function() { return /* binding */ truncateString; },
/* harmony export */   "dO": function() { return /* binding */ resolvedPublicPath; }
/* harmony export */ });
/* harmony import */ var lodash_es_lowerCase__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7167);
/* harmony import */ var lodash_es_kebabCase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(194);


const DOMAIN_URL = "https://www.yocale.com";
const getNameOfDay = ()=>{
    const days = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ];
    const d = new Date();
    return days[d.getDay()];
};
const generateBookingURL = (param)=>{
    let { uniqueIdentifier , type , id , locale  } = param;
    let link = "".concat(DOMAIN_URL, "/widget/").concat(uniqueIdentifier, "?lng=").concat(locale);
    switch(type){
        case "location":
            link += "&locations=".concat(id);
            break;
        case "provider":
            link += "&op=~".concat(id);
            break;
        case "service":
            link += "&op=".concat(id, "~");
            break;
        default:
            break;
    }
    return link;
};
const generateSocialShare = (param)=>{
    let { type , businessName , url  } = param;
    let link = "";
    switch(type){
        case "facebook":
            link += "https://facebook.com/sharer/sharer.php?u=".concat(url);
            break;
        case "twitter":
            link += "https://twitter.com/intent/tweet/?text=".concat(businessName, "&url=").concat(url);
            break;
        default:
            break;
    }
    return link;
};
const formatTime24 = (timeString)=>{
    const [hourString, minute] = timeString.split(":");
    const hour = +hourString % 24;
    return (hour % 12 || 12) + ":" + minute + (hour < 12 ? "AM" : "PM");
};
const truncateString = function(str) {
    let num = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 13;
    if (str.length <= num) {
        return str;
    }
    return str.slice(0, num) + "...";
};
const isProd = ()=>"production" === "production";
const resolvedPublicPath = (path)=>isProd() ? "/b/".concat(path) : "/".concat(path);
const toSearchEngineFriendlyWords = (input)=>{
    return encodeURIComponent((0,lodash_es_kebabCase__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,lodash_es_lowerCase__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(input)));
};
const generateSectionLabel = function(label, fallback) {
    let limit = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 13;
    if (!label) return fallback;
    return truncateString(label, limit);
};



/***/ })

}]);